"use client";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import { useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { adminDashboard } from "@/pages";
import { AdminBreadcrumb, AdminTitle } from "@/shared";

export function AdminMainPage() {
  const pagePath = [{ label: "홈", href: "/admin" }, { label: "매인" }];
  const pageTitle = pagePath[pagePath.length - 1].label;

  const calendarRef = useRef<FullCalendar>(null);

  const [start_date, setStart_date] = useState(
    moment().startOf("month").toString()
  );
  const [end_date, setEnd_date] = useState(moment().endOf("month").toString());

  const { data } = useQuery({
    queryKey: ["admin-dashboard", { start_date, end_date }],
    queryFn: () => adminDashboard({ start_date, end_date }),
  });

  // if (isLoading) return <></>;
  // if (error) return <></>;

  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <AdminBreadcrumb items={pagePath} />
          <AdminTitle title={pageTitle} />
        </div>
        <div className="ms-auto">
          <div className="mb-3px">
            <span className="badge me-1 bg-green">가입</span>
            <span className="badge me-1 bg-danger">로그인</span>
            <span className="badge bg-inverse">게시글</span>
          </div>
        </div>
      </div>

      <div className="row">
        {/* <div className="col-md-4">
          <MainUsers />
        </div>
        <div className="col-md-8">
          <MainStorages />
        </div> */}
        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, timeGridPlugin, bootstrapPlugin]}
          initialView="dayGridMonth"
          themeSystem="bootstrap"
          locale="ko"
          headerToolbar={{
            left: "dayGridMonth,timeGridWeek,timeGridDay",
            center: "title",
            right: "prev,next,today",
          }}
          allDayText="종일"
          buttonText={{
            month: "월",
            week: "주",
            day: "일",
            today: "오늘",
          }}
          customButtons={{
            dayGridMonth: {
              text: "월",
              click: () => {
                console.log("월");
                const calendarApi = calendarRef.current?.getApi() as any;
                calendarApi.changeView("dayGridMonth");

                const activeRange =
                  calendarApi.currentDataManager.state.dateProfile.activeRange;
                console.log(activeRange.start, activeRange.end);
                setStart_date(moment(activeRange.start).toString());
                setEnd_date(moment(activeRange.end).toString());
              },
            },
            timeGridWeek: {
              text: "주",
              click: () => {
                console.log("주");
                const calendarApi = calendarRef.current?.getApi() as any;
                calendarApi.changeView("timeGridWeek");

                const activeRange =
                  calendarApi.currentDataManager.state.dateProfile.activeRange;
                setStart_date(moment(activeRange.start).toString());
                setEnd_date(moment(activeRange.end).toString());
              },
            },
            timeGridDay: {
              text: "일",
              click: () => {
                console.log("일");
                const calendarApi = calendarRef.current?.getApi() as any;
                calendarApi.changeView("timeGridDay");

                const activeRange =
                  calendarApi.currentDataManager.state.dateProfile.activeRange;
                setStart_date(moment(activeRange.start).toString());
                setEnd_date(moment(activeRange.end).toString());
              },
            },
            today: {
              text: "오늘",
              click: () => {
                console.log("오늘");
                const calendarApi = calendarRef.current?.getApi() as any;
                calendarApi.today();

                const activeRange =
                  calendarApi.currentDataManager.state.dateProfile.activeRange;
                setStart_date(moment(activeRange.start).toString());
                setEnd_date(moment(activeRange.end).toString());
              },
            },
            prev: {
              text: "이전",
              click: () => {
                console.log("이전");
                const calendarApi = calendarRef.current?.getApi() as any;
                calendarApi.prev();

                const activeRange =
                  calendarApi.currentDataManager.state.dateProfile.activeRange;
                setStart_date(moment(activeRange.start).toString());
                setEnd_date(moment(activeRange.end).toString());
              },
            },
            next: {
              text: "다음",
              click: () => {
                console.log("다음");
                const calendarApi = calendarRef.current?.getApi() as any;
                calendarApi.next();

                const activeRange =
                  calendarApi.currentDataManager.state.dateProfile.activeRange;
                setStart_date(moment(activeRange.start).toString());
                setEnd_date(moment(activeRange.end).toString());
              },
            },
          }}
          dayMaxEvents={4}
          events={data?.result}
          height="calc(100vh - 150px)"
        />
      </div>
    </>
  );
}
